<div class="task-contributor-modal">
  <!-- Search users -->
  <div class="tc-search-wrap">
    <lucide-icon name="search" [size]="14" class="tc-search-icon" [strokeWidth]="2"></lucide-icon>
    <input
      type="text"
      class="tc-search-input"
      [(ngModel)]="searchText"
      (ngModelChange)="onSearchTextChange()"
      placeholder="Search team members..."
    />
  </div>

  <!-- User list -->
  <div class="tc-user-list">
    <div *ngIf="filteredListOfUsers.length === 0" class="tc-empty">
      No team members found.
    </div>

    <div class="tc-group-heading" *ngIf="filteredListOfUsers.length > 0">Team Members</div>

    <div
      class="tc-user-item"
      *ngFor="let user of filteredListOfUsers"
      [class.tc-user-item--selected]="user.isContributing"
      [class.tc-user-item--disabled]="isAssignee(user) || isPending(user)"
      [title]="isAssignee(user) ? 'This person is the assignee. Reassign the task first to change their role.' : null"
      (click)="(isAssignee(user) || isPending(user)) ? null : toggleUser(user); $event.stopPropagation()">
      <div class="tc-avatar">
        <img *ngIf="user.profilePictureUrl" [src]="user.profilePictureUrl" class="tc-avatar-img">
        <span *ngIf="!user.profilePictureUrl" class="tc-avatar-initials">{{ user.userInitials }}</span>
      </div>
      <span class="tc-user-name">{{ user.name }}</span>
      <lucide-icon *ngIf="user.isContributing" name="check" [size]="14" class="tc-check" [strokeWidth]="2"></lucide-icon>
    </div>
  </div>

  <!-- Current contributors -->
  <div class="tc-footer" *ngIf="currentContributorChips?.length">
    <div class="tc-footer-label">Contributing ({{ currentContributorChips.length }})</div>
    <div class="tc-chips">
      <span class="tc-chip" *ngFor="let contributor of currentContributorChips">
        <div class="tc-chip-avatar">
          <img *ngIf="contributor.profilePictureUrl" [src]="contributor.profilePictureUrl" class="tc-avatar-img">
          <span *ngIf="!contributor.profilePictureUrl">{{ getChipInitials(contributor) }}</span>
        </div>
        <span class="tc-chip-name">{{ getChipName(contributor) }}</span>
        <button
          *ngIf="canManageContributors"
          type="button"
          class="tc-chip-remove"
          (click)="removeContributor(getContributorId(contributor)); $event.stopPropagation()"
          aria-label="Remove contributor">
          <lucide-icon name="x" [size]="12" [strokeWidth]="2"></lucide-icon>
        </button>
      </span>
    </div>
  </div>
</div>

<!-- Remove-contributor confirmation modal (replaces the native window.confirm) -->
<div class="vf-confirm-overlay" *ngIf="showRemoveConfirm" (click)="cancelRemoveContributor()">
  <div class="vf-confirm-modal" (click)="$event.stopPropagation()">
    <h1 class="vf-confirm-title">Remove {{ pendingRemoveUserName }}?</h1>
    <p class="vf-confirm-text">This contributor has edited step(s) on this task. Removing them will unassign their step(s).</p>
    <div class="vf-confirm-footer">
      <button type="button" class="vf-confirm-btn vf-confirm-btn--cancel" (click)="cancelRemoveContributor()">Cancel</button>
      <button type="button" class="vf-confirm-btn vf-confirm-btn--primary" (click)="confirmRemoveContributor()">Remove</button>
    </div>
  </div>
</div>

<style>
.task-contributor-modal {
  padding: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.tc-search-wrap {
  position: relative;
  border-bottom: 1px solid rgb(229, 231, 235);
}
.tc-search-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
}
.tc-search-input {
  width: 100%;
  height: 36px;
  padding: 0 12px 0 32px;
  border: 0;
  background: transparent;
  font-size: 14px;
  color: #111827;
  outline: none;
  box-shadow: none;
  border-radius: 0;
  box-sizing: border-box;
}
.tc-search-input:focus { outline: none; box-shadow: none; }
.tc-search-input::placeholder { color: #9ca3af; }

.tc-group-heading {
  padding: 10px 12px 4px 12px;
  font-size: 11px;
  font-weight: 500;
  color: #6b7280;
}
.tc-user-list {
  max-height: 260px;
  overflow-y: auto;
}
.tc-empty {
  padding: 16px 12px;
  color: #9ca3af;
  font-size: 12px;
  text-align: center;
}
.tc-user-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid rgb(229, 231, 235);
  cursor: pointer;
  transition: background 0.15s;
}
.tc-user-item:last-child { border-bottom: 0; }
.tc-user-item:hover { background: #f3f4f6; }
.tc-user-item--selected { background: rgba(239, 246, 255, 1); }
.tc-user-item--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.tc-user-item--disabled:hover { background: transparent; }

.tc-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #4b5563;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}
.tc-avatar-img { width: 100%; height: 100%; object-fit: cover; }
.tc-avatar-initials { text-transform: uppercase; line-height: 1; }
.tc-user-name {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #111827;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tc-check { color: #2563eb; flex-shrink: 0; }

.tc-footer {
  padding: 12px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
}
.tc-footer-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
}
.tc-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.tc-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px 4px 8px;
  background: #f3f4f6;
  color: #374151;
  border-radius: 4px;
  font-size: 12px;
  max-width: 100%;
}
.tc-chip-avatar {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #d1d5db;
  color: #4b5563;
  font-size: 9px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}
.tc-chip-name {
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tc-chip-remove {
  padding: 1px;
  border: 0;
  background: transparent;
  color: #374151;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
}
.tc-chip-remove:hover { background: #e5e7eb; }

/* In-app confirm modal (mirrors the task-watcher confirm styling) */
.vf-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}
.vf-confirm-modal {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  width: 100%;
  max-width: 460px;
  padding: 20px 24px 16px;
}
.vf-confirm-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px;
}
.vf-confirm-text {
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 16px;
  line-height: 1.5;
}
.vf-confirm-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
.vf-confirm-btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  border: 0;
  transition: background 0.15s ease, color 0.15s ease;
}
.vf-confirm-btn--cancel {
  background: transparent;
  color: #374151;
}
.vf-confirm-btn--cancel:hover { background: #f3f4f6; }
.vf-confirm-btn--primary {
  background: #111827;
  color: #ffffff;
}
.vf-confirm-btn--primary:hover { background: #000000; }
</style>
